// extracted by mini-css-extract-plugin
export default {"primaryColorBase":"#003f52","primaryColorLight":"#035169","primaryColorLighter":"#0e86aa","primaryColorLightest":"#1eb8e6"};